import { getUrlPath } from './get-url-path';

export const isInternalLink = (to) => {
  const path = getUrlPath(to);
  const isInternal =
    (path?.startsWith('/') && !path?.startsWith('//')) || path?.startsWith('#');
  return isInternal;
};
